import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// landIeul: CaseDetail/ExampleList・ExperienceList の「さらに表示」。
// Next は GraphQL カーソル (first:6/after) で6件ずつ追加取得する。Rails も初期表示の 6 件だけを
// サーバー描画し、不足分は url から 6 件ずつカードの断片を取りに行く。
class SiteCaseCaseListController extends Controller<HTMLElement> {
  static targets = ["stack", "moreButton"];
  static values = { url: String, total: Number, shown: Number };

  declare readonly stackTarget: HTMLElement;
  declare readonly moreButtonTarget: HTMLButtonElement;
  declare readonly hasMoreButtonTarget: boolean;
  declare readonly urlValue: string;
  declare readonly totalValue: number;
  declare shownValue: number;

  async showMore(): Promise<void> {
    // 連打で二重に取りに行かない
    this.moreButtonTarget.disabled = true;
    try {
      const response = await fetch(`${this.urlValue}?offset=${this.shownValue}`);
      if (!response.ok) throw new Error(`${response.status}`);

      const template = document.createElement("template");
      template.innerHTML = await response.text();
      const added = template.content.children.length;
      this.shownValue += added;
      this.stackTarget.append(template.content);

      // 1 枚も返らなければ、総件数が描画後に減っている。押し続けても何も増えないのでボタンを消す。
      if (added === 0 || this.shownValue >= this.totalValue) {
        this.moreButtonTarget.remove();
        return;
      }
    } catch (error) {
      // 取得に失敗しても、すでに出ているカードはそのままにしてもう一度押せる状態に戻す
      console.error("[site--case--case-list] 追加取得に失敗しました", error);
    }
    if (this.hasMoreButtonTarget) this.moreButtonTarget.disabled = false;
  }
}

application.register("site--case--case-list", SiteCaseCaseListController);
